export default function BrowserPolicyRouteConfig($stateProvider, $urlRouterProvider, gettext) {
	'ngInject';

	$stateProvider.state('browser-policy', {
		url: '/browser-policy',
		template: '<browser-policy></browser-policy>'
	});
}
